/**
 * Default copy for approvals — submission blocked when patient info check fails.
 */
export const APPROVALS_SUBMISSION_BLOCKED_TITLE = "Submission Blocked";

export const APPROVALS_SUBMISSION_BLOCKED_VALIDATION_SUBTITLE =
  "Validation Failure: Rule [LIMS-402]";

export const APPROVALS_SUBMISSION_BLOCKED_ISSUE_HEADING = "Issue Detected";

export const APPROVALS_SUBMISSION_BLOCKED_ISSUE_QUOTED_FILE_PLACEHOLDER = "File_name.pdf";

export const APPROVALS_SUBMISSION_BLOCKED_ISSUE_HIGHLIGHT =
  "incomplete or missing patient information";

export const APPROVALS_SUBMISSION_BLOCKED_ISSUE_LINE_OPEN_QUOTE = "\u201c";

export const APPROVALS_SUBMISSION_BLOCKED_ISSUE_LINE_AFTER_FILENAME = "\u201d contains ";

export const APPROVALS_SUBMISSION_BLOCKED_ISSUE_LINE_SUFFIX = "";

export const APPROVALS_SUBMISSION_BLOCKED_MISSING_HEADING = "Missing Patient Details";

export const APPROVALS_SUBMISSION_BLOCKED_MISSING_DESCRIPTION =
  "LIMS policy requires full patient metadata (Name, DOB, Gender, and Account ID) to be visible or attached for document categorization.";

export const APPROVALS_SUBMISSION_BLOCKED_REPLACE_FILE = "REPLACE FILE";
